import { EquipmentCombinations } from 'fitbeat.models';
import {
  ConfigBasedSequence,
} from './configBaseSequence';
import {
  RestForFirstExercise,
  RestForSecondExercise,
  RestForThirdExercise,
  TrainForFirstExercise,
  TrainForSecondExercise,
  TrainForThirdExercise,
  TransitionForRest,
  TransitionForRestWithBenchInstruction,
  TransitionForTrain,
} from './content';

export class BuildTripple3Min extends ConfigBasedSequence {
  protected configForEachSequenceEntry = () => {
    const timeForRest = {
      bodyweightLite: 10,
      equipment : 15,
    };
    const timingForRestForFirstExerciseAtStartOfZone = {
      [EquipmentCombinations.BENCH_HUB_DUMBBELLS]: timeForRest.equipment+ 21,
      [EquipmentCombinations.BENCH_HUB_BANDS_ANCHOR_POINT] : timeForRest.equipment+ 21,
      [EquipmentCombinations.BENCH_DUMBBELLS]: timeForRest.equipment + 15,
      [EquipmentCombinations.BENCH_BANDS_ANCHOR_POINT]: timeForRest.equipment + 15,
      [EquipmentCombinations.BENCH_BANDS]: timeForRest.equipment + 9,
      [EquipmentCombinations.BANDS_ANCHOR_POINT]: timeForRest.equipment + 9,
      [EquipmentCombinations.DUMBBELLS]: timeForRest.equipment + 9,
      [EquipmentCombinations.BANDS]: timeForRest.equipment + 6,
      [EquipmentCombinations.BENCH]: timeForRest.equipment + 6,
      [EquipmentCombinations.BODYWEIGHT]: timeForRest.equipment,
      [EquipmentCombinations.BODYWEIGHT_LIGHT]: timeForRest.bodyweightLite,
      [EquipmentCombinations.BENCH_HUB]: timeForRest.equipment + 9,
      [EquipmentCombinations.BENCH_HUB_BANDS]: 30,
    };
    const timingForTraining = {
      [EquipmentCombinations.BENCH_HUB_DUMBBELLS]: 34,
      [EquipmentCombinations.BENCH_HUB_BANDS_ANCHOR_POINT] : 34,
      [EquipmentCombinations.BENCH_DUMBBELLS]: 36,
      [EquipmentCombinations.BENCH_BANDS_ANCHOR_POINT]: 36,
      [EquipmentCombinations.BENCH_BANDS]: 38,
      [EquipmentCombinations.BANDS_ANCHOR_POINT]: 38,
      [EquipmentCombinations.BODYWEIGHT]: 41,
      [EquipmentCombinations.BODYWEIGHT_LIGHT]: 46,
      [EquipmentCombinations.DUMBBELLS]: 38,
      [EquipmentCombinations.BANDS]: 39,
      [EquipmentCombinations.BENCH]: 39,
      [EquipmentCombinations.BENCH_HUB]: 38,
      [EquipmentCombinations.BENCH_HUB_BANDS]: 36,
    };

    return [
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForRestWithBenchInstruction(),
      },
      {
        timing: timingForRestForFirstExerciseAtStartOfZone,
        content: new RestForFirstExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForTrain(),
      },
      {
        timing: timingForTraining,
        content: new TrainForFirstExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForRest(),
      },
      {
        timing: timeForRest,
        content: new RestForSecondExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForTrain(),
      },
      {
        timing: timingForTraining,
        content: new TrainForSecondExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForRest(),
      },
      {
        timing: timeForRest,
        content: new RestForThirdExercise(),
      },
      {
        timing: { time: this.transitionDuration },
        content: new TransitionForTrain(),
      },
      {
        timing: timingForTraining,
        content: new TrainForThirdExercise(),
      },
    ];
  }
}
